<template>
  <div>
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>manage_accounts</md-icon>
        </div>
        <h4 class="title">Staff</h4>
      </md-card-header>
      <md-card-content>
        <md-toolbar md-elevation="0" class="md-transparent md-dense">
          <div class="md-toolbar-section-end">
            <md-button
              class="md-icon-button md-dense md-primary md-round"
              @click="newStaff"
            >
              <md-icon>add</md-icon>
              <md-tooltip md-direction="top">Add Staff</md-tooltip>
            </md-button>
          </div>
        </md-toolbar>
        <md-table v-model="staff" @md-selected="viewStaff">
          <md-table-row
            slot="md-table-row"
            slot-scope="{ item }"
            md-selectable="single"
          >
            <md-table-cell md-label="Name">
              <a href="#" @click.stop="viewStaff(item)">{{ item.full_name }}</a>
            </md-table-cell>
            <md-table-cell md-label="Country">
              {{ item.country }}
            </md-table-cell>
            <md-table-cell class="text-right">
              <md-button
                class="md-just-icon md-simple md-danger "
                @click.stop="deleteStaff(item)"
              >
                <md-icon>delete</md-icon>
                <md-tooltip md-direction="top">Delete</md-tooltip>
              </md-button>
              <md-button
                class="md-just-icon md-simple md-success"
                @click.stop="viewStaff(item)"
              >
                <md-icon>visibility</md-icon>
                <md-tooltip md-direction="top">View</md-tooltip>
              </md-button>
            </md-table-cell>
          </md-table-row>

          <md-table-empty-state
            md-label="Work, Work, Work..."
            :md-description="`Add Staff.`"
          >
            <md-button class="md-primary md-raised" @click="newStaff"
              >Add Staff</md-button
            >
          </md-table-empty-state>
        </md-table>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
export default {
  props: ["staff"],

  data() {
    return {};
  },

  components: {},

  methods: {
    newStaff() {
      this.$emit("addStaff");
    },

    viewStaff(staff) {
      this.$emit("viewStaff", staff);
    },

    deleteStaff(staff) {
      this.$emit("deleteStaff", staff);
    }
  },

  watch: {},

  mounted() {}
};
</script>
<style lang="scss" scoped>
.md-switch {
  margin: 0;
}
</style>
